module.exports = __webpack_public_path__ + "img/tabbed-search-filter-dark-kia.7ecc58e3.png";